import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { InputCompound } from '@usepepper/sprout-kit-ui';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useLayoutContext } from '@/contexts/layout-context';
import { View } from 'react-native';

interface Props {
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (depositNumber: string) => Promise<void>;
}

export const DepositNumberActionSheet: React.FC<Props> = ({
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [styles, theme] = useStyles();
  const { isSmallLayout } = useLayoutContext();
  const [depositNumber, setDepositNumber] = useState('');

  return (
    <BaseActionSheet
      isVisible
      onClose={() => {
        if (isSubmitting) {
          return;
        }

        onClose();
      }}
      title={i18n.t('bank_deposits.deposit_number_sheet.title')}
    >
      <View style={styles.container}>
        {isSmallLayout ? (
          <Typography color={theme.sk.color.text.primary} variant="heading-sm">
            {i18n.t('bank_deposits.deposit_number_sheet.title')}
          </Typography>
        ) : null}
        <Typography
          color={theme.sk.color.text.secondary}
          variant="paragraph-base"
        >
          {i18n.t('bank_deposits.deposit_number_sheet.subtitle')}
        </Typography>
        <InputCompound size="$56">
          <InputCompound.Label>
            {i18n.t('bank_deposits.deposit_number')}
          </InputCompound.Label>
          <InputCompound.Box>
            <InputCompound.Section>
              <InputCompound.Area
                accessibilityLabel={i18n.t('bank_deposits.deposit_number')}
                onChangeText={setDepositNumber}
                placeholder={i18n.t('bank_deposits.deposit_number_placeholder')}
                value={depositNumber}
              />
            </InputCompound.Section>
          </InputCompound.Box>
        </InputCompound>
        <Button
          accessibilityLabel={i18n.t('bank_deposits.confirm_deposit')}
          disabled={!depositNumber.trim()}
          loading={isSubmitting}
          onPress={() => onConfirm(depositNumber.trim())}
          trackingData={{ name: 'bank_deposits.confirm_deposit_button' }}
        >
          {i18n.t('bank_deposits.confirm_deposit')}
        </Button>
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceSMedium,
  },
}));
